<div class="container-fluid" style="padding: 20px 0 0 0; margin-bottom: 116px">
  <select class="form-select" id="inputGroupSelect01" (change)="selectProduct($event)">
    <option *ngFor="let product of products"
            [value]="product.id" [disabled]="isProductDisabled(product)"
            [selected]="product.id === selectedProduct">{{product.name}}</option>
  </select>
  <div class="card" style="margin-top: 20px; text-align: justify;">
    <div class="card-header">Produktinformationen</div>
    <div class="card-body">
      <div *ngIf="['LB', 'LB_NRW', 'LB_V_ALKIS', 'LB_V_ATKIS'].indexOf(selectedProduct) !== -1">
        <b>Erstableitung Landbedeckung</b>
        <p>Berechnung der Landbedeckung nach Gebiets- und Zeitraumauswahl. Manuelle Trainingsdaten können ausgewählt
          werden und das automatische Training ergänzen/ersetzen. Zudem können eigene Validierungsdaten ausgewählt
          werden. Falls eigene in-situ-Daten aus einem Upload verwendet werden sollen, muss die in-situ Upload-ID
          angegeben werden.</p>
      </div>
      <div *ngIf="['LB_V_ALKIS', 'LB_V_ATKIS', 'V_ALKIS', 'V_ATKIS'].indexOf(selectedProduct) !== -1">
        <b>Veränderungshinweissuche ALKIS</b>
        <p>Suche nach Veränderungshinweisen in einem ALKIS Datenbestand. Als Grundlage dient die Landbedeckung.
          Es können eigene ALKIS-Daten des Nutzers über eine Upload-ID ausgewählt werden.</p>
      </div>
      <div *ngIf="['V_LB'].indexOf(selectedProduct) !== -1">
        <b>Veränderungsinformation Landbedeckung</b>
        <p>Zunächst wird in jedem Fall eine neue Landbedeckung berechnet. Über die Upload-ID können dafür eigene
          in-situ-Daten ausgewählt werden. Zudem können eigene Trainings- und Validierunsdaten verwendet und das
          automatische Training aktiviert oder deaktiviert werden. Die neue berechnete Landbedeckung wird mit dem
          Landesbestand Landbedeckung oder mit der über eine Upload-ID identifizierte Landbedeckung des Nutzers
          verglichen, um Veränderungen abzuleiten.</p>
      </div>
    </div>
  </div>
</div>
